import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import Api, { createFetchErrorMessage } from "utils/api/Api";
import { toast } from 'react-toastify';
import { UserProfileInline } from "../components/UserProfileInline";

export const CommentForm = ({ type, root, className = "", mode = "create", comment = null, useCancel = false, onCancel = (f) => f, }) => {
    const queryClient = useQueryClient();
    const auth = useSelector(state => state.auth);
    const [content, setContent] = useState("");

    useEffect(() => {
        if (mode === 'modify' && comment) setContent(comment.content);
    }, [comment, mode])

    // -------------- 저장
    const commentStoreMutate = useMutation({
        mutationFn: (data) => Api.post('/api/comment/store', data),
        onSuccess: (res) => {
            setContent("");
            onCancel();
            queryClient.invalidateQueries({ queryKey: ['comment/list', type, root.id] });
        },
        onError: (err) => {
            toast.error(createFetchErrorMessage(err).message);
        }
    });

    const onSubmit = (e) => {
        e.preventDefault();
        if (commentStoreMutate.isPending) return;
        // 이건 뭔가 자못된겨
        if (mode !== 'create' && comment === null) return;

        const storeData = { id: null, content, type, rootId: root.id };
        if (mode === 'modify') {
            storeData.id = comment.id;
        } else if (mode === 'reply') {
            storeData.replyId = comment.id;
        }
        commentStoreMutate.mutate(storeData);
    };

    const onChangeContent = (event) => {
        let count = 0;
        let beforeLetter = event.target.value[0];
        for (let i = 1; i < event.target.value.length; i++) {
            if (beforeLetter === event.target.value[i]) {
                count++;
                if (count >= 10) {
                    toast.error("같은 글자를 10자 이상 반복 작성하지 말아주세요.");
                    return setContent("");
                }
            } else {
                count = 0;
                beforeLetter = event.target.value.length[i];
            }
        }
        setContent(event.target.value);
    };

    return (
        <div className={`input_wrap ${className} `}>
            {mode === "create" && auth.authenticated && <UserProfileInline id={auth.id} name={auth.name} image={auth.image} />}
            <div className="input">
                <textarea placeholder="댓글을 작성해 주세요" rows="1" name="content"
                    maxLength={500}
                    value={content} onChange={onChangeContent}></textarea>

                <button type="button" className="btn _blue" onClick={onSubmit}>저장</button>
                {useCancel && <button className="btn _xsm _gray btn_cancel" onClick={onCancel}>취소</button>}
            </div>
        </div>
    );
};